import "./bootstrap/customerPortalAccess";
// Capture customer capabilities before telemetry, then initialize Sentry before
// App's router import graph so route-aware tracing instruments router creation.
import "./instrument";
import "@fontsource-variable/geist/wght.css";
import "@fontsource-variable/geist/wght-italic.css";
import { safeConsole } from "@utils";
import ReactDOM from "react-dom/client";
import { startPageviewTracking } from "@/analytics/pageviewTracker";
import { bootstrapPostHog } from "@/analytics/posthog";
import { initNativeShellFixes } from "@/utils/nativeShell";
import App from "./App";
import { router } from "./router";

// Fetch the PostHog key/host from dale at runtime, then init — fire-and-forget.
// Init is async (a beat after load); default-opt-out + per-company gating defer
// all capture until post-login, so the slight delay loses nothing.
void bootstrapPostHog();
// Capture $pageview (normalized route pattern, no IDs/query) on every
// committed navigation. Wired once here — before render — so no navigation
// can slip past between mount and a React effect running.
startPageviewTracking(router);
// Capacitor-shell quirk fixes; instant no-op in ordinary browsers.
initNativeShellFixes();

// Render the app.
const rootElement = document.getElementById("app");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(<App />);
} else {
  safeConsole.error(
    "application-lifecycle",
    "Failed to find the root element.",
  );
}
